/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

export const OnboardingActions = {
  'SendConsumerPayment': 'SendConsumerPayment',
  'RegisterConsumerAccount': 'RegisterConsumerAccount',
  'SendCreditCardPayment': 'SendCreditCardPayment'
};
